/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const EDIT_PRICE = gql`
mutation Mutation($input: EditPriceInput) {
  editPrice(input: $input)
}
`;

export const EDIT_PRICE_IND = gql`
mutation Mutation($auth: AuthInput, $input: EditPriceInput) {
  editPrice(auth: $auth, input: $input)
}
`;

export const GET_ASSET_VOUCHER= gql`
query GetVoucherToSign($auth: AuthInput!, $input: CreateVoucherInput!) {
  getVoucherToSign(auth: $auth, input: $input) {
    address
    payload
  }
}
`;